import * as React from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Hero = ({ data }) => {
  // Remove all extensions at the end from image URL
  const imageUrl = data.content_image?.url || data.background?.url || '';
  const lastSlashIndex = imageUrl.lastIndexOf('/');
  let imageAltName = imageUrl.substring(lastSlashIndex + 1);
  
  // Remove extension if it exists
  imageAltName = imageAltName.replace(/\.[^.]+$/, '');
  
  // Remove additional characters after extension if present
  imageAltName = imageAltName.replace(/\.[^.]+$/, '');

  switch (data.layout) {
    case "Text full":
      return (
        <div
          className="hero grid col-span-12"
          style={{
            backgroundColor: data.background_color
              ? data.background_color
              : "transparent",
          }}
        >
          <div
            className="text h-auto col-span-12"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
        </div>
      );
    case "Text right with solid background":
      return (
        <div
          className={`hero-right-text col-span-12 ${data.attributes.class}`}
          style={{
            backgroundColor: data.background_color
              ? data.background_color
              : "transparent",
          }}
        >
          <img
            src={data.background.url}
            className="w-full h-full object-cover"
            alt={data?.background?.description ? data.background.description : imageAltName}
          />
          <div
            className="teaser"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
        </div>
      );
    case "Text left with solid background":
      return (
        <div
          className="hero-left-text col-span-12"
          style={{
            backgroundColor: data.background_color
              ? data.background_color
              : "transparent",
          }}
        >
          <img
            src={data.background.url}
            className="w-full h-full object-cover"
            alt={data?.background?.description ? data.background.description : imageAltName}
          />
          <div
            className="teaser"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
        </div>
      );
    case "Text right with solid background and self contained image":
      return (
        <div
          className={`hero-right-text-image col-span-12 ${data.attributes.class}`}
          style={{
            backgroundColor: data.background_color
              ? data.background_color
              : "#fff",
            backgroundSize: "cover",
            backgroundImage: "url(" + data.background.url + ")",
            backgroundPosition: "50% 50%",
          }}
        >
          <div className="teaser">
            <div className="content-wrapper">
              {data.content_image && (
                <div className="image-wrapper">
                  <div className="image-inner">
                    <img src={data.content_image.url} alt={data?.content_image?.description ? data.content_image.description : imageAltName} />
                  </div>
                </div>
              )}
              <div
                className="text-wrapper"
                dangerouslySetInnerHTML={{ __html: data.content }}
              />
            </div>
          </div>
        </div>
      );
    case "Text left with solid background and self contained image":
      return (
        <div
          className={
              `hero-left-text-image col-span-12`
          }
          style={{
            backgroundColor: data.background_color
              ? data.background_color
              : "#fff",
            backgroundSize: "cover",
            backgroundImage: "url(" + data.background.url + ")",
            backgroundPosition: "50% 50%",
          }}
        >
          <div className="teaser">
            <div className="content-wrapper">
              <div
                className="text-wrapper"
                dangerouslySetInnerHTML={{ __html: data.content }}
              />
              {data.content_image && (
                <div className="image-wrapper">
                  <div className="image-inner">
                    <img src={data.content_image.url} alt={data?.content_image?.description ? data.content_image.description : imageAltName} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    case "Vertical half page with self contained image":
      return (
        <div
          className="hero-vertical col-span-12 md:col-span-6"
          style={{
            backgroundColor: data.background_color
              ? data.background_color
              : "transparent",
            backgroundSize: "cover",
            backgroundImage: "url(" + data.background.url + ")",
            backgroundPosition: "50% 50%",
          }}
        >
          <div className="teaser">
            <div className="content-wrapper">
              {data.content_image && (
                <div className="image-wrapper">
                  <div className="image-inner">
                    <img src={data.content_image.url} alt={data?.content_image?.description ? data.content_image.description : imageAltName} />
                  </div>
                </div>
              )}
              <div
                className="text-wrapper"
                dangerouslySetInnerHTML={{ __html: data.content }}
              />
            </div>
          </div>
        </div>
      );
    case "Text right":
      return (
        <div
          className={`hero-text-right col-span-12 grid grid-cols-12 ${data.attributes.class}`}
          style={{
            backgroundColor: data.background_color
              ? data.background_color
              : "transparent",
          }}
        >
          <div
            className={classNames(
              "hidden md:block",
              data.ratio === "1/1"
                ? "md:col-span-6"
                : data.ratio === "5/9"
                ? "md:col-span-5"
                : data.ratio === "7/5"
                ? "md:col-span-7"
                : "md:col-span-6"
            )}
          >
            <img
              src={data.content_image.url}
              className="h-full w-full object-cover"
              alt={data?.content_image?.description ? data.content_image.description : imageAltName}
            />
          </div>
          <div
            className={classNames(
              "text-wrapper col-span-12",
              data.ratio === "1/1"
                ? "md:col-span-6"
                : data.ratio === "5/9"
                ? "md:col-span-7"
                : data.ratio === "7/5"
                ? "md:col-span-5"
                : "md:col-span-6"
            )}
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
        </div>
      );
    case "Text left":
      return (
        <div
          className={`hero-text-left col-span-12 grid grid-cols-12 ${data.attributes.class}`}
          style={{
            backgroundColor: data.background_color
              ? data.background_color
              : "transparent",
          }}
        >
          <div
            className={classNames(
              "text-wrapper col-span-12",
              data.ratio === "1/1"
                ? "md:col-span-6"
                : data.ratio === "5/9"
                ? "md:col-span-5"
                : data.ratio === "7/5"
                ? "md:col-span-7"
                : "md:col-span-6"
            )}
            dangerouslySetInnerHTML={{ __html: data.content }}
          ></div>
          <div
            className={classNames(
              "col-span-12 md:block",
              data.ratio === "1/1"
                ? "md:col-span-6"
                : data.ratio === "5/9"
                ? "md:col-span-7"
                : data.ratio === "7/5"
                ? "md:col-span-5"
                : "md:col-span-6"
            )}
          >
            <img
              src={data.content_image.url}
              className="h-full w-full object-cover"
              alt={data?.content_image?.description ? data.content_image.description : imageAltName}
            />
          </div>
        </div>
      );
    default:
      return null;
  }
};

export default Hero;
